import {combineReducers} from 'redux';
import studentsList from './studentsList';
import savedSearches from './savedSearches';
import savedProfiles from './savedProfiles';
import talentReadyGraph from './talentReadyGraphMetrics';

export const talentExchangeReducer = combineReducers({
  studentsList,
  savedSearches,
  savedProfiles,
  talentReadyGraph,
});
